import { useSelector } from "react-redux";

export default function useAuth() {
    const auth = useSelector((state) => state.auth);
    if (auth?.accessToken && auth?.user) {
        if (auth.user.role === 'admin') {
            return { isLoggedIn: true, role: 'admin' };
        } else if (auth.user.role === 'student') {
            return { isLoggedIn: true, role: 'student', name: auth.user.name, id: auth.user.id };
        } else {
            return { isLoggedIn: false, role: null };
        }
    } else {
        return { isLoggedIn: false, role: null };
    }
}
